// context/AuthContext.js
import React, { createContext, useContext, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(() => {
    // Load user from localStorage if available
    const savedUser = localStorage.getItem('role');
    return savedUser ? savedUser : null;
  });

  const login = (token, user) => {
    try {
      const decodedToken = jwtDecode(token);
    //   console.log(user);
      setUserRole(user.role);
      setIsLoggedIn(true);
      localStorage.setItem('token', token);
      localStorage.setItem('email', user.email);
      localStorage.setItem('names', user.first_name + ' ' + user.last_name);  
      localStorage.setItem('role', user.role);  
    } catch (error) {
      console.error('Invalid token:', error);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('names');
    localStorage.removeItem('role');
    localStorage.removeItem('selectedCompany');
    setIsLoggedIn(false);
    setUserRole(null);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
